import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "../style/Media.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import jad from "../images/Jad.jpeg";
import tala from "../images/Tala.jpeg";
import maya from "../images/Maya.jpeg";
import rami from "../images/rami.jpeg";
import karim from "../images/karim.jpeg";

const YoutubeShorts = () => {
  const slider = React.useRef(null);
  // const videoData = [
  //   {
  //     title: "Maha",
  //     src: "https://www.youtube.com/embed/14z8m0lnUog",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Jad",
  //     src: "https://www.youtube.com/embed/kLxqINKs-EI",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Patrick",
  //     src: "https://www.youtube.com/embed/atbtxJeIELE",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Ivanya",
  //     src: "https://www.youtube.com/embed/dJb9zIZuay8",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Mohamad",
  //     src: "https://www.youtube.com/embed/x2DrVwAqzZo",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Reem",
  //     src: "https://www.youtube.com/embed/q3WCGIIo4a8",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Laura",
  //     src: "https://www.youtube.com/embed/sUUqj73fT4c",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Amir",
  //     src: "https://www.youtube.com/embed/b9zzTtUkuZs",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Hadi",
  //     src: "https://www.youtube.com/embed/oam3j9kfTgQ",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Michelle",
  //     src: "https://www.youtube.com/embed/Sh5ycq0buBw",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Linda",
  //     src: "https://www.youtube.com/embed/REL8d-UV-pI",
  //     description: "crowded teeth",
  //   },
  //   {
  //     title: "Leen",
  //     src: "https://www.youtube.com/embed/mTgFkdTz8mo",
  //     description: "crowded teeth",
  //   },
  // ];

  const imgData = [
    {
      title: "Jad",
      src: jad,
      description: "crowded teeth",
    },
    {
      title: "Tala",
      src: tala,
      description: "crowded teeth",
    },
    {
      title: "Rami",
      src: rami,
      description: "crowded teeth",
    },
    {
      title: "Maya",
      src: maya,
      description: "spaced teeth",
    },
    {
      title: "Karim",
      src: karim,
      description: "crowded teeth",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className={styles.carouselContainer}>
      <h2 className={styles.subtitle}>Authentic Smiles, Genuine Results</h2>
      <h2 className={styles.title}>
        Everyone deserves to feel confident in their smile
      </h2>
      <Slider {...settings} ref={slider}>
        {/* {videoData.map((video, index) => (
          <div key={index} className={styles.videoWrapper}>
            <iframe
              className={styles.video}
              src={video.src}
              title={video.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <h3 className={styles.videoTitle}>{video.title}</h3>
            <p className={styles.videoDescription}>{video.description}</p>
          </div>
        ))} */}

        {imgData.map((video, index) => (
          <div key={index} className={styles.videoWrapper}>
            <img
              className={styles.image}
              src={video.src}
              title={video.title}
              alt={video.title}
            />
            <h3 className={styles.videoTitle}>{video.title}</h3>
            <p className={styles.videoDescription}>{video.description}</p>
          </div>
        ))}
      </Slider>
      <div className={styles.buttonWrapper}>
        <button
          onClick={() => slider?.current?.slickPrev()}
          className={`${styles.customButton} ${styles.prevButton}`}
        >
          <FontAwesomeIcon icon={faChevronLeft} size="2x" />
        </button>
        <button
          className={`${styles.customButton} ${styles.nextButton}`}
          onClick={() => slider?.current?.slickNext()}
        >
          <FontAwesomeIcon icon={faChevronRight} size="2x" />
        </button>
      </div>
    </div>
  );
};

export default YoutubeShorts;
